import { CanDeactivateFn } from '@angular/router';
import type { CreateTenantPageComponent } from './create-tenant-page.component';

export const createTenantUnsavedChangesGuard: CanDeactivateFn<CreateTenantPageComponent> = (component) =>
	component.requestDiscardChangesConfirmation();
